module.exports = __webpack_public_path__ + "img/2.29c23ad1.jpg";